import { Grid } from '@mui/material';
import { useState } from 'react';
import { WsColors, ScrollableTabs, TabTextVariant } from 'wisestep-base';

import CandidateCallLogs from '../../../../features/conversationWidget/components/CanddidateCallLogs';
import CandidateSmsLogs from '../../../../features/conversationWidget/components/CandidateSmsLogs';
import EmailLogs from '../../../../features/conversationWidget/components/EmailLogs';
import { useCandidateViewData } from '../../utils/CandidateViewContext';

const tabData = [
  {
    tabName: 'Call',
  },
  {
    tabName: 'SMS',
  },
  {
    tabName: 'Email',
  },
];
const CommunicationLogs = () => {
  const { candidateViewData } = useCandidateViewData();
  const candidate = candidateViewData;
  const [planIndex, setPlanIndex] = useState<number>(2);

  return (
    <>
      {candidate && (
        <Grid container sx={{ background: WsColors.White }}>
          <Grid
            item
            xs={12}
            height="35%"
            borderRadius={2}
            sx={{ background: WsColors.White }}
            id="communicationlogsScrollable"
          >
            <ScrollableTabs
              scrollList={tabData}
              getTabIndex={setPlanIndex}
              defaultValue={2}
              variant={TabTextVariant.SUB_TITLE}
            />
          </Grid>
          <Grid item xs={12} sx={{ background: WsColors.White }} p={1}>
            {planIndex == 0 && <CandidateCallLogs candidate={candidate} />}
            {planIndex == 1 && <CandidateSmsLogs candidate={candidate} />}
            {planIndex == 2 && <EmailLogs candidate={candidate} />}
          </Grid>
        </Grid>
      )}
    </>
  );
};
export default CommunicationLogs;
